import React, { useState, useEffect } from 'react';
import './Home.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { FaUsers, FaBriefcase, FaChartLine, FaRegLightbulb, FaStar, FaShieldAlt, FaHandshake, FaUserTie, FaBuilding, FaLightbulb } from 'react-icons/fa';
import { GiBrain, GiDiamondHard } from 'react-icons/gi';
import { FiArrowUpRight } from 'react-icons/fi';
import Leadermessage from '../Leadermessage/Leadermessage';
const App = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
      offset: 100, // Trigger animations a bit later
    });
  }, []);

  const heroSlides = [
    {
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=90',
      headline: "Innovate. Integrate. Inspire.",
      subheadline: 'Adhvik & Adhrit Manpower & Consultancy: Pioneering solutions for a dynamic business world. Your vision, our expertise.',
      animationType: 'hero-zoom-pan',
    },
    {
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=90',
      headline: "Strategic Talent. Lasting Impact.",
      subheadline: 'Unlock unparalleled potential with our bespoke manpower and insightful consultancy services.',
      animationType: 'hero-slide-stagger',
    },
    {
      image: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=90',
      headline: "Navigate Complexity. Achieve Clarity.",
      subheadline: 'Expert guidance to transform challenges into strategic advantages for market leadership.',
      animationType: 'hero-reveal-up',
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % heroSlides.length);
    }, 7500);
    return () => clearTimeout(timer);
  }, [currentSlide, heroSlides.length]);

  const services = [
    { icon: <FaUserTie />, title: 'Executive & Leadership Search', description: 'Precision-driven acquisition of visionary leaders to steer your enterprise.' },
    { icon: <FaUsers />, title: 'Niche Talent Acquisition', description: 'Connecting you with specialized professionals for critical roles.' },
    { icon: <GiBrain />, title: 'Strategic HR & Org. Design', description: 'Transformative consulting for optimized structures and talent strategies.' },
    { icon: <FaBuilding />, title: 'Agile Project Workforce', description: 'Scalable, expert teams for your most demanding projects.' },
    { icon: <FaLightbulb />, title: 'Innovation & Growth Strategy', description: 'Advisory services to foster innovation and achieve sustainable market growth.' },
    { icon: <GiDiamondHard />, title: 'Performance Excellence Consulting', description: 'Maximizing your team\'s potential and overall organizational productivity.' },
  ];

  // Helper to split headline for letter animation (optional, can be complex)
  // const splitText = (text) => {
  //   return text.split("").map((char, i) => (
  //     <span key={i} style={{ animationDelay: `${i * 0.05}s` }} className="char-animate">
  //       {char === " " ? "\u00A0" : char}
  //     </span>
  //   ));
  // };

  return (
    <div className="App">
      <div className="animated-gradient-background"></div>
      <div className="background-decor-shapes">
        <div className="decor-shape decor-shape1"></div>
        <div className="decor-shape decor-shape2"></div>
        <div className="decor-shape decor-shape3"></div>
      </div>

      <section id="home" className="hero-section">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? `active-slide ${slide.animationType}` : ''}`}
          >
            <div className="hero-slide-bg" style={{ backgroundImage: `url(${slide.image})` }}></div>
            <div className="hero-overlay-gradient"></div>
            <div className="hero-content-wrapper">
              <div className="hero-content">
                <div className="hero-logo-area" data-aos="fade-down" data-aos-delay="100" data-aos-anchor=".hero-section">
                    <span className="main-logo-text-hero">Adhvik & Adhrit</span>
                    <span className="sub-logo-text-hero">Manpower & Consultancy Pvt. Ltd.</span>
                </div>
                {/* For simpler animation, direct h1. For letter animation, use splitText or CSS only techniques */}
                <h1 className="hero-headline" data-aos="zoom-out-up" data-aos-delay="300" data-aos-duration="1200" data-aos-anchor=".hero-section">
                  {slide.headline}
                </h1>
                <p className="hero-subheadline" data-aos="fade-up" data-aos-delay="600" data-aos-duration="1000" data-aos-anchor=".hero-section">{slide.subheadline}</p>
                <a href="#contact" className="cta-button hero-cta-button" data-aos="fade-up" data-aos-delay="900" data-aos-duration="1000" data-aos-anchor=".hero-section">
                  Explore Our Expertise
                  <span className="cta-arrow">→</span>
                </a>
              </div>
            </div>
          </div>
        ))}
      </section>

      <section id="about" className="section-padding about-section-stunning">
        <div className="container">
          <div className="about-grid-stunning">
            <div className="about-text-stunning" data-aos="fade-right" data-aos-duration="1200">
              <h2 className="section-title">Visionary <span className="highlight">Partnerships</span>. Tangible <span className="highlight">Results</span>.</h2>
              <p>Adhvik & Adhrit Manpower & Consultancy is your strategic ally in navigating the evolving world of talent and business growth. We forge powerful connections, merging visionary organizations with exceptional individuals to unlock unprecedented potential.</p>
              <p>Our approach is rooted in deep industry understanding, innovative strategies, and an unwavering commitment to delivering excellence. We are not just service providers; we are architects of success, dedicated to shaping a prosperous future for your enterprise.</p>
            </div>
            <div className="about-image-interactive-wrapper" data-aos="fade-left" data-aos-duration="1200" data-aos-delay="200">
              <div className="about-image-interactive">
                <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1769&q=90" alt="Strategic Business Collaboration" />
                <div className="image-accent-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="section-padding services-section-stunning">
        <div className="container">
          <h2 className="section-title" data-aos="zoom-in-down">Our Suite of <span className="highlight">Strategic Solutions</span></h2>
          <div className="services-grid-stunning-v2">
            {services.map((service, index) => (
              <div className="service-card-stunning-v2" key={index} data-aos="fade-up" data-aos-delay={100 + index * 150}>
                <div className="service-card-inner">
                  <div className="service-icon-area">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <span className="service-card-accent-line"></span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="why-us" className="section-padding why-us-section-stunning bg-patterned-light">
        <div className="container">
          <h2 className="section-title" data-aos="fade-up">The Adhvik & Adhrit <span className="highlight">Difference</span></h2>
          <div className="why-us-grid-stunning-v2">
            <div className="why-us-item-stunning-v2" data-aos="zoom-in-right" data-aos-duration="900">
              <div className="why-us-icon-bg"><FaStar /></div>
              <h3>Precision in Placement</h3>
              <p>We match the right talent with the right role, every time.</p>
            </div>
            <div className="why-us-item-stunning-v2" data-aos="zoom-in" data-aos-duration="900" data-aos-delay="200">
              <div className="why-us-icon-bg"><FaHandshake /></div>
              <h3>People-Centric Philosophy</h3>
              <p>Empowering individuals fuels long-term success for businesses.</p>
            </div>
            <div className="why-us-item-stunning-v2" data-aos="zoom-in-left" data-aos-duration="900" data-aos-delay="400">
              <div className="why-us-icon-bg"><FaShieldAlt /></div>
              <h3>Consulting Beyond Contracts</h3>
              <p>We offer strategic insights to drive sustainable growth.</p>
            </div>
          </div>
        </div>
      </section>
      
      <section id="directors" className="section-padding directors-section-stunning">
        <div className="container">
          <h2 className="section-title" data-aos="slide-right" data-aos-duration="1000">Guiding <span className="highlight">Vision</span>, Driving <span className="highlight">Momentum</span></h2>
        
      <Leadermessage/>
        </div>
      </section>


      {/* Section 2: CTA (Based on Final CTA - Immersive) */}
      <section id="contact" className="section-padding cta-final-section-focused">
        <div className="container cta-focused-content" data-aos="zoom-out-up" data-aos-duration="1500">
          <h2 className="cta-focused-headline">Ready to Redefine <br/>Your <span className="highlight-text-stroke-cta">Success</span>?</h2>
          <p className="cta-focused-subheadline">Partner with Adhvik & Adhrit to navigate the future of talent and strategy. Let's build something extraordinary, together.</p>
          <a href="mailto:abhinav.sen@adhvikandadhrit.com" className="cta-button-primary-focused cta-focused-button">
            Begin Your Transformation <FiArrowUpRight className="cta-icon-focused" />
          </a>
          <div className="contact-info-minimal-focused" data-aos="fade-in" data-aos-delay="500">
            <p>Email: <a href="mailto:abhinav.sen@adhvikandadhrit.com">abhinav.sen@adhvikandadhrit.com</a>  |  Phone: +91 8209327724</p>
          
          </div>
        </div>
        <div className="cta-background-elements-focused">
          <div className="cta-bg-shape-focused cta-bg-shape-f1"></div>
          <div className="cta-bg-shape-focused cta-bg-shape-f2"></div>
        </div>
      </section>
      {/* Section 1: Our Philosophy (Based on About Us - Narrative) */}
      <section id="philosophy" className="section-padding philosophy-section-narrative">
        <div className="container">
          <div className="philosophy-narrative-grid">
            <div className="philosophy-intro-text" data-aos="fade-right" data-aos-duration="1000">
              <h2 className="section-title-left-aligned-philosophy">
                <span className="title-prefix-philosophy">Our Philosophy</span>
                Architecting <span className="highlight">Futures</span>, Powering <span className="highlight">Progress</span>.
              </h2>
              <p>Adhvik & Adhrit Consultants Services transcends traditional boundaries. We are catalysts for transformation, meticulously crafting synergies between visionary organizations and exceptional talent. Our journey is defined by a relentless pursuit of excellence and a profound understanding of the forces shaping modern enterprise.</p>
              <p>We believe in fostering environments where innovation thrives and potential is limitless. Our commitment is to empower your vision with strategic insights and unparalleled human capital solutions, driving sustainable growth and market leadership.</p>
            </div>
            <div className="philosophy-visual-story" data-aos="zoom-in-up" data-aos-duration="1200">
              <div className="visual-story-card-philosophy card-p1">
                <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=90" alt="Strategic Planning Session"/>
                <div className="card-caption-philosophy">Insight & Strategy</div>
              </div>
               <div className="visual-story-card-philosophy card-p2">
                <img src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=90" alt="Collaborative Teamwork"/>
                <div className="card-caption-philosophy">Talent Synergy</div>
              </div>
              <div className="visual-story-card-philosophy card-p3">
                <img src="https://images.unsplash.com/photo-1497091071254-cc9b2ba7c48a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1742&q=90" alt="Business Growth Chart"/>
                <div className="card-caption-philosophy">Measurable Growth</div>
              </div>
            </div>
          </div>
        </div>
      </section>
<section id="contact" className="section-padding cta-final-section-stunning">
        <div className="container" data-aos="zoom-out" data-aos-duration="1500">
          <h2 className="section-title light-title">Ready to Elevate Your <span className="highlight-alt">Enterprise</span>?</h2>
          <p className="light-text">Partner with Adhvik & Adhrit to transform your vision into reality. Let's build a future defined by growth, innovation, and unparalleled success.</p>
          <a href="mailto:abhinav.sen@adhvikandadhrit.com" className="cta-button-alt-stunning large-cta">
            Initiate a Consultation
          </a>
         
        </div>
      </section>
       <div className="master-background-layer-minimal">
        {/* Minimalist background elements if needed */}
      </div>
    </div>
    
  );
};

export default App;